import { Form } from "react-bootstrap";

const TextArea = (props) => {
    return (
        <Form.Group>
            <Form.Label>{props.required && '*'} {props.label}</Form.Label>
            <Form.Control
                {...props.register}
                aria-label={props.label}
                as="textarea" rows={props.rows}
            />
            <Form.Control.Feedback type="invalid" style={props.errors ? {display: 'block'} : {display: 'none'}}>This field is required</Form.Control.Feedback>
        </Form.Group>
    )
}

export default TextArea;